import React, { useEffect, useState } from 'react'
import './online.css'

const Online = ({id}) => {

      const [online, setOnline] = useState([]) 

      async function getOnline(id_xat){
            const url = `https://oceanbot.net/online.php?id=${id_xat}` 

            try{
                  const response = await fetch(url) 
                  const result = await response.json()
                  setOnline(result)
            }
            catch(err){
                  console.log('Error: ' + err)
            }
      }

      id.replace('M', '000000')

      useEffect(() => {
            getOnline(id)
      }, [id])

      if(online.length === 0) return 

      return (
            <div className="online_content flex">
                  <div className={online.status === 'online' ? "online_dot green" : "online_dot red"}></div>
                  <span>{online.status === 'online' ? "Online Now" : "Offline"}</span>
            </div>
      )
}

export default Online
